import { initEventBus } from '@repo/single-spa';
import { usePostHog } from 'posthog-js/react';
import { useEffect } from 'react';

const eventBus = initEventBus();

export function PostHogEventHandler() {
  const posthog = usePostHog();

  useEffect(() => {
    if (!posthog) return;

    // Handle capture events
    const handleCapture = ({ event, properties }: { event: string; properties?: Record<string, any> }) => {
      posthog.capture(event, properties);
    };

    // Handle identify events
    const handleIdentify = ({ distinctId, properties }: { distinctId: string; properties?: Record<string, any> }) => {
      posthog.identify(distinctId, properties);
    };

    // Handle reset events
    const handleReset = ({ resetDeviceId }: { resetDeviceId?: boolean }) => {
      posthog.reset(resetDeviceId);
    };

    // Register event listeners
    eventBus.on('posthog:capture', handleCapture);
    eventBus.on('posthog:identify', handleIdentify);
    eventBus.on('posthog:reset', handleReset);

    // Cleanup listeners on unmount
    return () => {
      eventBus.off('posthog:capture', handleCapture);
      eventBus.off('posthog:identify', handleIdentify);
      eventBus.off('posthog:reset', handleReset);
    };
  }, [posthog]);

  return null; // This component doesn't render anything
}